/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Totaux du détail de tarification d'un tunnel.
 * @export
 * @interface TarificationTotauxDto
 */
export interface TarificationTotauxDto {
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    primePure?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    majoration?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    minoration?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    primePureTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    sommeRemunerations?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    prixHT?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    taxe?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    prixTTC?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    sommeFraisHT?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    sommeTaxeFrais?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    sommeFraisTTC?: number;
    /**
     * 
     * @type {number}
     * @memberof TarificationTotauxDto
     */
    prixClient?: number;
}

/**
 * Check if a given object implements the TarificationTotauxDto interface.
 */
export function instanceOfTarificationTotauxDto(value: object): value is TarificationTotauxDto {
    return true;
}

export function TarificationTotauxDtoFromJSON(json: any): TarificationTotauxDto {
    return TarificationTotauxDtoFromJSONTyped(json, false);
}

export function TarificationTotauxDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TarificationTotauxDto {
    if (json == null) {
        return json;
    }
    return {
        
        'primePure': json['primePure'] == null ? undefined : json['primePure'],
        'majoration': json['majoration'] == null ? undefined : json['majoration'],
        'minoration': json['minoration'] == null ? undefined : json['minoration'],
        'primePureTotal': json['primePureTotal'] == null ? undefined : json['primePureTotal'],
        'sommeRemunerations': json['sommeRemunerations'] == null ? undefined : json['sommeRemunerations'],
        'prixHT': json['prixHT'] == null ? undefined : json['prixHT'],
        'taxe': json['taxe'] == null ? undefined : json['taxe'],
        'prixTTC': json['prixTTC'] == null ? undefined : json['prixTTC'],
        'sommeFraisHT': json['sommeFraisHT'] == null ? undefined : json['sommeFraisHT'],
        'sommeTaxeFrais': json['sommeTaxeFrais'] == null ? undefined : json['sommeTaxeFrais'],
        'sommeFraisTTC': json['sommeFraisTTC'] == null ? undefined : json['sommeFraisTTC'],
        'prixClient': json['prixClient'] == null ? undefined : json['prixClient'],
    };
}

export function TarificationTotauxDtoToJSON(json: any): TarificationTotauxDto {
    return TarificationTotauxDtoToJSONTyped(json, false);
}

export function TarificationTotauxDtoToJSONTyped(value?: TarificationTotauxDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primePure': value['primePure'],
        'majoration': value['majoration'],
        'minoration': value['minoration'],
        'primePureTotal': value['primePureTotal'],
        'sommeRemunerations': value['sommeRemunerations'],
        'prixHT': value['prixHT'],
        'taxe': value['taxe'],
        'prixTTC': value['prixTTC'],
        'sommeFraisHT': value['sommeFraisHT'],
        'sommeTaxeFrais': value['sommeTaxeFrais'],
        'sommeFraisTTC': value['sommeFraisTTC'],
        'prixClient': value['prixClient'],
    };
}

